// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/1_release.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./images/2_release.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./images/3_release.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./images/1_release_mobile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./images/2_release_mobile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./images/3_release_mobile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./images/dreamscape_full.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Comfortaa:wght@300..700&family=Patrick+Hand&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Comfortaa:wght@300..700&family=Gloria+Hallelujah&family=Patrick+Hand&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 23vmin;
  pointer-events: none;
}

h1, h2, h3, h4, h5, h6 {
  font-size: revert;
  font-weight: revert;
}

.family {
  font-family: "Gloria Hallelujah", cursive;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-size:0.6em;
}

.mid-family {
  font-family: "Comfortaa", sans-serif;
  font-optical-sizing: auto;
  font-weight: 800;
  font-style: normal;
  font-size:1.6em;
}

.hero-family {
  font-family: "Comfortaa", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: normal;
  font-size:1.4em;
}
.comfortaa-family {
  font-family: "Comfortaa", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: normal;
}
.button:hover {
  background-color: #fec5bb;
}
.button {
  background-color: #fcd5ce;
}

.release_1 {
  width: 25%; /* as @passatgt mentioned in the comment, for the older browsers fallback */
  height:auto;;
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size:contain;
  background-repeat: no-repeat;
  background-position:center;
}

.wrapper{
  display:-webkit-flex;
  -webkit-justify-content:center;

  display:flex;
  justify-content:center;

}

.release_2 {
  width: 25%; /* as @passatgt mentioned in the comment, for the older browsers fallback */
  height:auto;
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size:contain;
  background-repeat: no-repeat;
  background-position:center;

}
.release_3 {
  width: 25%; /* as @passatgt mentioned in the comment, for the older browsers fallback */
  height:auto;
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size:contain;
  background-repeat: no-repeat;
  background-position:center;
}


.release_1_mobile {
  width: 25%; /* as @passatgt mentioned in the comment, for the older browsers fallback */
  height:auto;
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size:contain;
  background-repeat: no-repeat;
  background-position:center;

}

.release_2_mobile {
  width: 25%; /* as @passatgt mentioned in the comment, for the older browsers fallback */
  height:auto;
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size:contain;
  background-repeat: no-repeat;
  background-position:center;

}

.release_3_mobile {
  width: 25%; /* as @passatgt mentioned in the comment, for the older browsers fallback */
  height:auto;
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size:contain;
  background-repeat: no-repeat;
  background-position:center;

}

.background {
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size:contain;
  background-repeat: no-repeat;
  background-position:center;
}
.App-header {
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.unselectable {
  -webkit-user-select: none;
  user-select: none;
}
.App-link {
  color: #61dafb;
}

.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;

}

.app {
  display: grid;
  grid-template-columns: 20px 1fr 20px;
}
.app > * {
  grid-column: 2 / -2;
}
.app > .full {
  grid-column: 1 / -1;
}
.hs {
  display: grid;
  grid-gap: 40px;
  grid-template-columns:
    10px
    repeat(9, calc(50% - 0px))
    10px;
  grid-template-rows: minmax(150px, 1fr);
  
}
.hs:before,
.hs:after {
  content: '';
  width: 10px;
}

.hs > li:last-child {
  margin-right: 20px;
}

.scrolling-wrapper-flexbox {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  max-width:200;

  white-space: nowrap;
}

.scrolling-card {
  min-width:200px;
  min-height:200px;
  margin-right:20px;
 display:inline-block;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU,EAAE,2EAA2E;EACvF,WAAW;EACX,wDAA8C;EAC9C,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;;EAE9B,YAAY;EACZ,sBAAsB;;AAExB;;AAEA;EACE,UAAU,EAAE,2EAA2E;EACvF,WAAW;EACX,wDAA8C;EAC9C,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;;AAE5B;AACA;EACE,UAAU,EAAE,2EAA2E;EACvF,WAAW;EACX,wDAA8C;EAC9C,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;AAC5B;;;AAGA;EACE,UAAU,EAAE,2EAA2E;EACvF,WAAW;EACX,wDAAqD;EACrD,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;;AAE5B;;AAEA;EACE,UAAU,EAAE,2EAA2E;EACvF,WAAW;EACX,wDAAqD;EACrD,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;;AAE5B;;AAEA;EACE,UAAU,EAAE,2EAA2E;EACvF,WAAW;EACX,wDAAqD;EACrD,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;;AAE5B;;AAEA;EACE,wDAAoD;EACpD,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,yBAAyB;EAGzB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;EACd;;;QAGM;EACN,sCAAsC;;AAExC;AACA;;EAEE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;;EAEb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;CAClB,oBAAoB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Comfortaa:wght@300..700&family=Patrick+Hand&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Comfortaa:wght@300..700&family=Gloria+Hallelujah&family=Patrick+Hand&display=swap');\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 23vmin;\n  pointer-events: none;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-size: revert;\n  font-weight: revert;\n}\n\n.family {\n  font-family: \"Gloria Hallelujah\", cursive;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  font-size:0.6em;\n}\n\n.mid-family {\n  font-family: \"Comfortaa\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 800;\n  font-style: normal;\n  font-size:1.6em;\n}\n\n.hero-family {\n  font-family: \"Comfortaa\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 700;\n  font-style: normal;\n  font-size:1.4em;\n}\n.comfortaa-family {\n  font-family: \"Comfortaa\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 700;\n  font-style: normal;\n}\n.button:hover {\n  background-color: #fec5bb;\n}\n.button {\n  background-color: #fcd5ce;\n}\n\n.release_1 {\n  width: 25%; /* as @passatgt mentioned in the comment, for the older browsers fallback */\n  height:auto;;\n  background-image:url(\"./images/1_release.png\");\n  background-size:contain;\n  background-repeat: no-repeat;\n  background-position:center;\n}\n\n.wrapper{\n  display:-webkit-flex;\n  -webkit-justify-content:center;\n\n  display:flex;\n  justify-content:center;\n\n}\n\n.release_2 {\n  width: 25%; /* as @passatgt mentioned in the comment, for the older browsers fallback */\n  height:auto;\n  background-image:url(\"./images/2_release.png\");\n  background-size:contain;\n  background-repeat: no-repeat;\n  background-position:center;\n\n}\n.release_3 {\n  width: 25%; /* as @passatgt mentioned in the comment, for the older browsers fallback */\n  height:auto;\n  background-image:url(\"./images/3_release.png\");\n  background-size:contain;\n  background-repeat: no-repeat;\n  background-position:center;\n}\n\n\n.release_1_mobile {\n  width: 25%; /* as @passatgt mentioned in the comment, for the older browsers fallback */\n  height:auto;\n  background-image:url(\"./images/1_release_mobile.png\");\n  background-size:contain;\n  background-repeat: no-repeat;\n  background-position:center;\n\n}\n\n.release_2_mobile {\n  width: 25%; /* as @passatgt mentioned in the comment, for the older browsers fallback */\n  height:auto;\n  background-image:url(\"./images/2_release_mobile.png\");\n  background-size:contain;\n  background-repeat: no-repeat;\n  background-position:center;\n\n}\n\n.release_3_mobile {\n  width: 25%; /* as @passatgt mentioned in the comment, for the older browsers fallback */\n  height:auto;\n  background-image:url(\"./images/3_release_mobile.png\");\n  background-size:contain;\n  background-repeat: no-repeat;\n  background-position:center;\n\n}\n\n.background {\n  background-image:url(\"./images/dreamscape_full.png\");\n  background-size:contain;\n  background-repeat: no-repeat;\n  background-position:center;\n}\n.App-header {\n  min-height: 200px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.unselectable {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.App-link {\n  color: #61dafb;\n}\n\n.scrolling-wrapper {\n  overflow-x: scroll;\n  overflow-y: hidden;\n  white-space: nowrap;\n\n}\n\n.app {\n  display: grid;\n  grid-template-columns: 20px 1fr 20px;\n}\n.app > * {\n  grid-column: 2 / -2;\n}\n.app > .full {\n  grid-column: 1 / -1;\n}\n.hs {\n  display: grid;\n  grid-gap: 40px;\n  grid-template-columns:\n    10px\n    repeat(9, calc(50% - 0px))\n    10px;\n  grid-template-rows: minmax(150px, 1fr);\n  \n}\n.hs:before,\n.hs:after {\n  content: '';\n  width: 10px;\n}\n\n.hs > li:last-child {\n  margin-right: 20px;\n}\n\n.scrolling-wrapper-flexbox {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  max-width:200;\n\n  white-space: nowrap;\n}\n\n.scrolling-card {\n  min-width:200px;\n  min-height:200px;\n  margin-right:20px;\n display:inline-block;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
